import { render, staticRenderFns } from "./SuccessCheck.vue?vue&type=template&id=20a406f8"
import script from "./SuccessCheck.vue?vue&type=script&lang=js"
export * from "./SuccessCheck.vue?vue&type=script&lang=js"
import style0 from "./SuccessCheck.vue?vue&type=style&index=0&id=20a406f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports